var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiningArea = function SvgDiningArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diningArea_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.26 3.44c-.2 0-.363.163-.363.363V6.7h-.724V3.803a.362.362 0 1 0-.724 0V6.7H.724V3.803a.362.362 0 1 0-.724 0v4.346l1.81 1.448L3.623 8.15V3.803c0-.2-.162-.363-.362-.363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.26 8.148H.362L0 8.167c0 .337.079.67.23.971h.024l.833 1.667v9.03a.724.724 0 0 0 1.448 0v-9.02l.839-1.677h.018c.151-.301.23-.634.23-.971zM24 4.201a.36.36 0 0 0-.428-.356 2.174 2.174 0 0 0-1.745 2.13V12.7q0 .085.038.162l.686 1.372v5.581c0 .39.3.726.69.744.416.02.759-.311.759-.723zM12.362 3.803v16.756a8.378 8.378 0 0 0 0-16.756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M19.292 12.181c0-4.627-3.103-8.378-6.93-8.378a8.378 8.378 0 1 0 0 16.756c3.827 0 6.93-3.75 6.93-8.378"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diningArea_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDiningArea;